import { IMForm } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const IMFormStyled = styled(IMForm)`
  margin: 0 auto;
  max-width: 50rem;
  padding: 0;
`;
